import React, { useEffect } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="container mx-auto px-5 py-10">
      <section id="refund-policy" className="refund-policy">
        <div className="container mx-auto">
          <div className="text-center">
            <h2 className="text-4xl font-bold mb-5">Privacy Policy</h2>
            <p className="text-gray-600">Last Updated: 17.09.2024 (v1.0)</p>
          </div>

          <div className="mt-10 space-y-10">
            <p>
              Welcome to Cruze, a platform designed to provide seamless travel
              experiences and ticket booking services. This privacy policy
              explains how we collect, use, disclose, and safeguard your
              information when you use our services, including cab booking,
              ticketing through Cruze, and any future services we may offer.
            </p>

            {/* Information We Collect */}
            <div>
              <h3 className="text-2xl font-semibold">Information We Collect</h3>
              <p className="mt-2">We collect the following types of information:</p>
              <ul className="list-disc list-inside pl-4">
                <li>
                  <strong>Personal Information:</strong> Your name, contact information, payment details, and preferences.
                </li>
                <li>
                  <strong>Usage and Device Information:</strong> Device details, IP addresses, and usage patterns.
                </li>
              </ul>
            </div>

            {/* How We Use Your Information */}
            <div>
              <h3 className="text-2xl font-semibold">How We Use Your Information</h3>
              <p className="mt-2">We use the information we collect for:</p>
              <ul className="list-disc list-inside pl-4">
                <li>
                  <strong>Provide Services:</strong> To facilitate cab bookings, ticket purchases, and related services.
                </li>
                <li>
                  <strong>Personalization:</strong> To customize your experience and improve our services.
                </li>
                <li>
                  <strong>Communication:</strong> To send service updates, promotions, and important notices.
                </li>
              </ul>
            </div>

            {/* Information Sharing */}
            <div>
              <h3 className="text-2xl font-semibold">Information Sharing</h3>
              <p className="mt-2">
                <strong>Third-Party Providers:</strong> We may share your information with service providers who assist
                in delivering our services (e.g., payment processors, customer support) and business partners for joint
                promotions or collaborations.
              </p>
              <p>
                <strong>Legal Compliance and Protection:</strong> We may disclose information to comply with legal
                obligations or respond to lawful requests, and to protect our rights, property, or safety, or that of
                others.
              </p>
            </div>

            {/* Your Choices and Rights */}
            <div>
              <h3 className="text-2xl font-semibold">Your Choices and Rights</h3>
              <p className="mt-2">You have the following choices regarding your information:</p>
              <ul className="list-disc list-inside pl-4">
                <li>Access, update, or delete your information.</li>
                <li>Opt-out of receiving marketing communications.</li>
                <li>Disable cookies through your browser settings.</li>
              </ul>
            </div>

            {/* Security of Your Information */}
            <div>
              <h3 className="text-2xl font-semibold">Security of Your Information</h3>
              <p className="mt-2">
                We implement security measures to protect your information from unauthorized access and maintain data accuracy.
              </p>
            </div>

            {/* Policy Updates */}
            <div>
              <h3 className="text-2xl font-semibold">Policy Updates</h3>
              <p className="mt-2">
                We may update this privacy policy from time to time. We will notify you of any changes by posting the new
                policy on our website.
              </p>
            </div>

            {/* Contact Us */}
            <div>
              <h3 className="text-2xl font-semibold">Contact Us</h3>
              <p className="mt-2">
                If you have any questions or concerns about our privacy practices or this policy, please contact us at{" "}
                <a href="mailto:admin@cruze.asia" className="text-blue-600 hover:underline">
                  admin@cruze.asia
                </a>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
